import { H as se, g as P, C as B, f as fr, Y as ur, s as mr, p as pr, E as dr, Z as hr, Q as Er, P as L, _ as O, d as ke, e as Cr, j as ve, D as Ve, G as Fe, k as $r } from "./export-cdcbfb2b.js";
import { e as ce } from "./environment-is-node-a035d787.js";
import { o as Or } from "./object-set-prototype-of-7d7e5736.js";
import { s as Sr, d as Ge } from "./iterate-13ada9e5.js";
import { s as Ir } from "./set-species-5ede2ed0.js";
import { a as Rr } from "./an-instance-6efcfd6c.js";
import { s as Tr } from "./species-constructor-00346775.js";
import { f as Pr } from "./function-apply-4756dee6.js";
import { f as xe } from "./es.object.to-string-f55666a8.js";
import { h as Nr } from "./html-32ef1b46.js";
import { a as br } from "./array-slice-79f93c56.js";
import { v as yr } from "./validate-arguments-length-eb516e5b.js";
import { s as gr } from "./safe-get-built-in-a8d8c20c.js";
import { c as _r } from "./check-correctness-of-iteration-7d57c70c.js";
import { e as wr } from "./environment-ddee5959.js";
var jr = se, He = /(?:ipad|iphone|ipod).*applewebkit/i.test(jr), o = P, Dr = Pr, Mr = xe, Ee = B, Ar = mr, Je = fr, Ce = Nr, Ur = br, $e = ur, Br = yr, Lr = He, kr = ce, X = o.setImmediate, ee = o.clearImmediate, Vr = o.process, G = o.Dispatch, Fr = o.Function, Oe = o.MessageChannel, Gr = o.String, x = 0, I = {}, Se = "onreadystatechange", T, f, H, J;
Je(function() {
  T = o.location;
});
var le = function(e) {
  if (Ar(I, e)) {
    var r = I[e];
    delete I[e], r();
  }
}, W = function(e) {
  return function() {
    le(e);
  };
}, Ie = function(e) {
  le(e.data);
}, Re = function(e) {
  o.postMessage(Gr(e), T.protocol + "//" + T.host);
};
(!X || !ee) && (X = function(r) {
  Br(arguments.length, 1);
  var t = Ee(r) ? r : Fr(r), a = Ur(arguments, 1);
  return I[++x] = function() {
    Dr(t, void 0, a);
  }, f(x), x;
}, ee = function(r) {
  delete I[r];
}, kr ? f = function(e) {
  Vr.nextTick(W(e));
} : G && G.now ? f = function(e) {
  G.now(W(e));
} : Oe && !Lr ? (H = new Oe(), J = H.port2, H.port1.onmessage = Ie, f = Mr(J.postMessage, J)) : o.addEventListener && Ee(o.postMessage) && !o.importScripts && T && T.protocol !== "file:" && !Je(Re) ? (f = Re, o.addEventListener("message", Ie, !1)) : Se in $e("script") ? f = function(e) {
  Ce.appendChild($e("script"))[Se] = function() {
    Ce.removeChild(this), le(e);
  };
} : f = function(e) {
  setTimeout(W(e), 0);
});
var We = {
  set: X,
  clear: ee
}, Ke = function() {
  this.head = null, this.tail = null;
};
Ke.prototype = {
  add: function(e) {
    var r = { item: e, next: null }, t = this.tail;
    t ? t.next = r : this.head = r, this.tail = r;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var r = this.head = e.next;
      return r === null && (this.tail = null), e.item;
    }
  }
};
var Qe = Ke, xr = se, Hr = /ipad|iphone|ipod/i.test(xr) && typeof Pebble < "u", Jr = se, Wr = /web0s(?!.*chrome)/i.test(Jr), C = P, Kr = gr, Te = xe, K = We.set, Qr = Qe, Yr = He, Zr = Hr, qr = Wr, Q = ce, Pe = C.MutationObserver || C.WebKitMutationObserver, Ne = C.document, be = C.process, y = C.Promise, re = Kr("queueMicrotask"), p, Y, Z, g, ye;
if (!re) {
  var _ = new Qr(), w = function() {
    var e, r;
    for (Q && (e = be.domain) && e.exit(); r = _.get(); )
      try {
        r();
      } catch (t) {
        throw _.head && p(), t;
      }
    e && e.enter();
  };
  !Yr && !Q && !qr && Pe && Ne ? (Y = !0, Z = Ne.createTextNode(""), new Pe(w).observe(Z, { characterData: !0 }), p = function() {
    Z.data = Y = !Y;
  }) : !Zr && y && y.resolve ? (g = y.resolve(void 0), g.constructor = y, ye = Te(g.then, g), p = function() {
    ye(w);
  }) : Q ? p = function() {
    be.nextTick(w);
  } : (K = Te(K, C), p = function() {
    K(w);
  }), re = function(e) {
    _.head || p(), _.add(e);
  };
}
var zr = re, Xr = function(e, r) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, r);
  } catch {
  }
}, fe = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (r) {
    return { error: !0, value: r };
  }
}, et = P, k = et.Promise, rt = P, R = k, tt = B, at = pr, nt = hr, it = dr, ge = wr, q = Er;
R && R.prototype;
var ot = it("species"), te = !1, Ye = tt(rt.PromiseRejectionEvent), st = at("Promise", function() {
  var e = nt(R), r = e !== String(R);
  if (!r && q === 66)
    return !0;
  if (!q || q < 51 || !/native code/.test(e)) {
    var t = new R(function(i) {
      i(1);
    }), a = function(i) {
      i(function() {
      }, function() {
      });
    }, n = t.constructor = {};
    if (n[ot] = a, te = t.then(function() {
    }) instanceof a, !te)
      return !0;
  }
  return !r && (ge === "BROWSER" || ge === "DENO") && !Ye;
}), N = {
  CONSTRUCTOR: st,
  REJECTION_EVENT: Ye,
  SUBCLASSING: te
}, S = {}, _e = L, vt = TypeError, ct = function(e) {
  var r, t;
  this.promise = new e(function(a, n) {
    if (r !== void 0 || t !== void 0)
      throw new vt("Bad Promise constructor");
    r = a, t = n;
  }), this.resolve = _e(r), this.reject = _e(t);
};
S.f = function(e) {
  return new ct(e);
};
var lt = O, A = ce, l = P, $ = ve, we = ke, je = Or, ft = Sr, ut = Ir, mt = L, M = B, pt = Ve, dt = Rr, ht = Tr, Ze = We.set, ue = zr, Et = Xr, Ct = fe, $t = Qe, qe = Cr, U = k, me = N, ze = S, V = "Promise", Xe = me.CONSTRUCTOR, Ot = me.REJECTION_EVENT, St = me.SUBCLASSING, z = qe.getterFor(V), It = qe.set, d = U && U.prototype, u = U, j = d, er = l.TypeError, ae = l.document, pe = l.process, ne = ze.f, Rt = ne, Tt = !!(ae && ae.createEvent && l.dispatchEvent), rr = "unhandledrejection", Pt = "rejectionhandled", De = 0, tr = 1, Nt = 2, de = 1, ar = 2, D, Me, bt, Ae, nr = function(e) {
  var r;
  return pt(e) && M(r = e.then) ? r : !1;
}, ir = function(e, r) {
  var t = r.value, a = r.state === tr, n = a ? e.ok : e.fail, i = e.resolve, c = e.reject, s = e.domain, v, b, m;
  try {
    n ? (a || (r.rejection === ar && gt(r), r.rejection = de), n === !0 ? v = t : (s && s.enter(), v = n(t), s && (s.exit(), m = !0)), v === e.promise ? c(new er("Promise-chain cycle")) : (b = nr(v)) ? $(b, v, i, c) : i(v)) : c(t);
  } catch (F) {
    s && !m && s.exit(), c(F);
  }
}, or = function(e, r) {
  e.notified || (e.notified = !0, ue(function() {
    for (var t = e.reactions, a; a = t.get(); )
      ir(a, e);
    e.notified = !1, r && !e.rejection && yt(e);
  }));
}, sr = function(e, r, t) {
  var a, n;
  Tt ? (a = ae.createEvent("Event"), a.promise = r, a.reason = t, a.initEvent(e, !1, !0), l.dispatchEvent(a)) : a = { promise: r, reason: t }, !Ot && (n = l["on" + e]) ? n(a) : e === rr && Et("Unhandled promise rejection", t);
}, yt = function(e) {
  $(Ze, l, function() {
    var r = e.facade, t = e.value, a = Ue(e), n;
    if (a && (n = Ct(function() {
      A ? pe.emit("unhandledRejection", t, r) : sr(rr, r, t);
    }), e.rejection = A || Ue(e) ? ar : de, n.error))
      throw n.value;
  });
}, Ue = function(e) {
  return e.rejection !== de && !e.parent;
}, gt = function(e) {
  $(Ze, l, function() {
    var r = e.facade;
    A ? pe.emit("rejectionHandled", r) : sr(Pt, r, e.value);
  });
}, h = function(e, r, t) {
  return function(a) {
    e(r, a, t);
  };
}, E = function(e, r, t) {
  e.done || (e.done = !0, t && (e = t), e.value = r, e.state = Nt, or(e, !0));
}, ie = function(e, r, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === r)
        throw new er("Promise can't be resolved itself");
      var a = nr(r);
      a ? ue(function() {
        var n = { done: !1 };
        try {
          $(
            a,
            r,
            h(ie, n, e),
            h(E, n, e)
          );
        } catch (i) {
          E(n, i, e);
        }
      }) : (e.value = r, e.state = tr, or(e, !1));
    } catch (n) {
      E({ done: !1 }, n, e);
    }
  }
};
if (Xe && (u = function(r) {
  dt(this, j), mt(r), $(D, this);
  var t = z(this);
  try {
    r(h(ie, t), h(E, t));
  } catch (a) {
    E(t, a);
  }
}, j = u.prototype, D = function(r) {
  It(this, {
    type: V,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new $t(),
    rejection: !1,
    state: De,
    value: null
  });
}, D.prototype = we(j, "then", function(r, t) {
  var a = z(this), n = ne(ht(this, u));
  return a.parent = !0, n.ok = M(r) ? r : !0, n.fail = M(t) && t, n.domain = A ? pe.domain : void 0, a.state === De ? a.reactions.add(n) : ue(function() {
    ir(n, a);
  }), n.promise;
}), Me = function() {
  var e = new D(), r = z(e);
  this.promise = e, this.resolve = h(ie, r), this.reject = h(E, r);
}, ze.f = ne = function(e) {
  return e === u || e === bt ? new Me(e) : Rt(e);
}, M(U) && d !== Object.prototype)) {
  Ae = d.then, St || we(d, "then", function(r, t) {
    var a = this;
    return new u(function(n, i) {
      $(Ae, a, n, i);
    }).then(r, t);
  }, { unsafe: !0 });
  try {
    delete d.constructor;
  } catch {
  }
  je && je(d, j);
}
lt({ global: !0, constructor: !0, wrap: !0, forced: Xe }, {
  Promise: u
});
ft(u, V, !1);
ut(V);
var _t = k, wt = _r, jt = N.CONSTRUCTOR, vr = jt || !wt(function(e) {
  _t.all(e).then(void 0, function() {
  });
}), Dt = O, Mt = ve, At = L, Ut = S, Bt = fe, Lt = Ge, kt = vr;
Dt({ target: "Promise", stat: !0, forced: kt }, {
  all: function(r) {
    var t = this, a = Ut.f(t), n = a.resolve, i = a.reject, c = Bt(function() {
      var s = At(t.resolve), v = [], b = 0, m = 1;
      Lt(r, function(F) {
        var cr = b++, he = !1;
        m++, Mt(s, t, F).then(function(lr) {
          he || (he = !0, v[cr] = lr, --m || n(v));
        }, i);
      }), --m || n(v);
    });
    return c.error && i(c.value), a.promise;
  }
});
var Vt = O, Ft = N.CONSTRUCTOR, oe = k, Gt = Fe, xt = B, Ht = ke, Be = oe && oe.prototype;
Vt({ target: "Promise", proto: !0, forced: Ft, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
if (xt(oe)) {
  var Le = Gt("Promise").prototype.catch;
  Be.catch !== Le && Ht(Be, "catch", Le, { unsafe: !0 });
}
var Jt = O, Wt = ve, Kt = L, Qt = S, Yt = fe, Zt = Ge, qt = vr;
Jt({ target: "Promise", stat: !0, forced: qt }, {
  race: function(r) {
    var t = this, a = Qt.f(t), n = a.reject, i = Yt(function() {
      var c = Kt(t.resolve);
      Zt(r, function(s) {
        Wt(c, t, s).then(a.resolve, n);
      });
    });
    return i.error && n(i.value), a.promise;
  }
});
var zt = O, Xt = S, ea = N.CONSTRUCTOR;
zt({ target: "Promise", stat: !0, forced: ea }, {
  reject: function(r) {
    var t = Xt.f(this), a = t.reject;
    return a(r), t.promise;
  }
});
var ra = $r, ta = Ve, aa = S, na = function(e, r) {
  if (ra(e), ta(r) && r.constructor === e)
    return r;
  var t = aa.f(e), a = t.resolve;
  return a(r), t.promise;
}, ia = O, oa = Fe, sa = N.CONSTRUCTOR, va = na;
oa("Promise");
ia({ target: "Promise", stat: !0, forced: sa }, {
  resolve: function(r) {
    return va(this, r);
  }
});
